import { useEffect, useState } from "react";

/**
 * Hook that detects and returns the aspect ratio of a video element.
 * Returns null until the video metadata is loaded.
 */
export const useVideoAspectRatio = (
  videoRef: React.RefObject<HTMLVideoElement | null>
): number | null => {
  const [aspectRatio, setAspectRatio] = useState<number | null>(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const updateAspectRatio = () => {
      const { videoWidth, videoHeight } = videoElement;
      if (videoWidth && videoHeight) {
        setAspectRatio(videoWidth / videoHeight);
      }
    };
    updateAspectRatio();

    videoElement.addEventListener("loadedmetadata", updateAspectRatio);
    videoElement.addEventListener("canplay", updateAspectRatio);
    videoElement.addEventListener("resize", updateAspectRatio);

    return () => {
      videoElement.removeEventListener("loadedmetadata", updateAspectRatio);
      videoElement.removeEventListener("canplay", updateAspectRatio);
      videoElement.removeEventListener("resize", updateAspectRatio);
    };
  }, [videoRef]);

  return aspectRatio;
};
